import PropTypes from 'prop-types';

/**
 *
 */
const entryShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  state: PropTypes.string.isRequired,
  sequence: PropTypes.number.isRequired,
  menuLabel: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
});

export { entryShape };
